import { render, staticRenderFns } from "./DelixPlus.vue?vue&type=template&id=4739fc84&"
import script from "./DelixPlus.vue?vue&type=script&lang=js&"
export * from "./DelixPlus.vue?vue&type=script&lang=js&"
import style0 from "./DelixPlus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports